// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recap-iframe {
    display: block;
    width: 100%;
    border: 0;
    background: #fff;
    margin-top: max(10vh, 60px);
    min-height: calc(100vh - max(10vh, 60px));
}
`, "",{"version":3,"sources":["webpack://./src/components/Recap.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,2BAA2B;IAC3B,yCAAyC;AAC7C","sourcesContent":[".recap-iframe {\n    display: block;\n    width: 100%;\n    border: 0;\n    background: #fff;\n    margin-top: max(10vh, 60px);\n    min-height: calc(100vh - max(10vh, 60px));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
